import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { axiosPrivate } from "../../api/axios";

const ProfileLoginHistoryVisibilityToggle = ({
  auth,
  isTestUser,
  onBlocked,
  setError
}) => {
  const { t } = useTranslation();
  const userId = auth?.userId;

  const [isVisible, setIsVisible] = useState(auth.loginHistoryVisibility ?? false);
  const [isSaving, setIsSaving] = useState(false);
  const [showInfo, setShowInfo] = useState(false)

  const handleShowInfo = () => {
    setShowInfo(prev => !prev)
  }

  const handleToggle = async () => {
    if (isTestUser || isSaving) {
      if (isTestUser) onBlocked();
      return;
    }

    setIsSaving(true);
    const newVisibility = !isVisible;
    setShowInfo(false);


    try {
      const response = await axiosPrivate.put(`/users/${userId}/login-history-visibility`, {
        loginHistoryVisibility: newVisibility,
      });

      setIsVisible(newVisibility);
    } catch (error) {
      console.error('Error updating admin visibility:', error);
      setError(t('profile.failedToUpdateVisibility')); // 
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    // Update isVisible with the latest value from auth object if it changes
    setIsVisible(auth.loginHistoryVisibility ?? false);  // Default to false if undefined
  }, [auth.loginHistoryVisibility]);

  return (
    <>
      <div className='format-like-white-button'>
        <div>
          <div className="toggle-wrapper">
            <input
              type="checkbox"
              id="loginHistoryVisibility"
              className="toggle-checkbox"
              checked={isVisible}
              disabled={isSaving}
              onChange={handleToggle}
            />
            <label htmlFor="loginHistoryVisibility" className="toggle-label">
              <span className="toggle-circle"></span>
            </label>
          </div>
        </div>
        <div className='admin-setup-line-text'>
          {isVisible
            ?
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {t('profile.loginHistoryVisibilityOn')}
              <button
                className='profile-info-button'

                onClick={handleShowInfo}
              >{t('socialMuted.infoButton')}</button>
            </div>
            :
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {t('profile.loginHistoryVisibilityOff')}
              <button
                className='profile-info-button'

                onClick={handleShowInfo}
              >{t('socialMuted.infoButton')}</button>
            </div>
          }
        </div>
      </div>
      {showInfo && <>   {t('profile.loginHistoryVisibilityInfo')}</>}
    </>
  );
};

export default ProfileLoginHistoryVisibilityToggle;
